import React from 'react';
import { useDispatch } from 'react-redux';

import { setShowPaymentInput, addExactTapToPayPayment } from 'actions/Payments';
import {
  tapToPayCaption,
  tapToPayExactCaption,
} from 'paymentIntegrations/wrapper/constants';

const AddTapToPayPayment = ({ disabled = false, exact = false }) => {
  const dispatch = useDispatch();

  const buttonTitle = exact ? tapToPayExactCaption : tapToPayCaption;

  const handleClick = () => {
    if (exact) {
      dispatch(addExactTapToPayPayment());
    } else {
      dispatch(setShowPaymentInput(true, 'CARD', true));
    }
  };

  return (
    <li className="payment-item card-payment" style={{ cursor: 'pointer' }}>
      <div
        tabIndex={0}
        className="button"
        role="button"
        onClick={() => handleClick()}
        style={{
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      >
        {/** Do we need this className on mobile payments at all? IMO looks better without (text is centered to the button) */}
        <span className="title">{buttonTitle}</span>
      </div>
    </li>
  );
};

export default AddTapToPayPayment;
